<template>
  <div>
    <div class="d-flex mb-4">
      <div class="align-self-center me-2">
        <img
          class="align-self-center cursor-pointer"
          src="@/assets/images/back_arrow.png"
          alt=""
          height="16"
          width="16"
          @click="
            () => {
              this.$router.push({ name: 'login' });
            }
          "
        />
      </div>
      <div class="box-title mb-0">Forgot Password</div>
    </div>

    <div class="mb-4">
      Don't have an account yet?
      
      <a style="color: rgba(var(--bs-link-color-rgb)); cursor: pointer;" @click="showAccountUnavailable">Create your account</a>
    </div>

    <div
      v-if="isShowError"
      class="alert alert-danger alert-outline alert-dismissible fade show"
      role="alert"
    >
      <i class="uil uil-exclamation-octagon font-size-16 text-danger me-2"></i>
      {{ errorMessage }}
      <button type="button" class="btn-close" @click="closeError"></button>
    </div>

    <div class="mb-4">
      Enter the email address associated with your account and we will send you 6-digit code to reset your password.
    </div>
    <ValidationObserver v-slot="{ handleSubmit, reset }">
      <b-form
        ref="resetPasswordForm"
        @submit.prevent="handleSubmit(requestResetPassword)"
        @reset.prevent="reset"
      >
        <b-form-group class="mb-4">
          <label>Email Address</label>
          <validation-provider
            name="email"
            rules="required|email"
            v-slot="validationContext"
          >
            <b-form-input
              :state="getValidationState(validationContext)"
              placeholder="Enter Email Address"
              v-model="username"
              trim
            ></b-form-input>
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-form-group>

        <b-button
          class="w-100"
          variant="primary"
          type="submit"
          :disabled="isRequestLoading"
        >
          <span
            v-if="isRequestLoading"
            class="spinner-grow spinner-grow-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Send
        </b-button>
      </b-form>
    </ValidationObserver>
    <account-creation-unavailable-modal ref="accountModal" />
  </div>
</template>

<script>
import { authMethods } from "@/state/helpers";
import AccountCreationUnavailableModal from '@/components/AccountCreationUnavailableModal.vue';

export default {
  components: {
    AccountCreationUnavailableModal
  },
  props: ["value"],
  data() {
    return {
      isShowError: false,
      errorMessage: null,
      isRequestLoading: false,
      username: this.value,
    };
  },
  watch: {
    value: {
      handler(val) {
        this.username = val;
      },
    },
    username: {
      handler(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    ...authMethods,
    closeError() {
      this.isShowError = false;
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
     showAccountUnavailable() {
      if (this.$refs && this.$refs.accountModal && typeof this.$refs.accountModal.show === 'function') {
        this.$refs.accountModal.show();
      }
    },
    requestResetPassword() {
      this.isRequestLoading = true;
      this.errorMessage = null;
      this.isShowError = false;
      this.forgotPassword(this.username)
        .then(() => {
          this.isRequestLoading = false;
          this.$emit("success");
        })
        .catch((err) => {
          var message = err.message;
          this.isRequestLoading = false;
          if (err.message == "Username/client id combination not found.") {
            message = "Email does not exist.";
          }
          this.errorMessage = message;
          this.isShowError = true;
        });
    },
  },
};
</script>

<style>
.cursor-pointer {
  cursor: pointer;
}
</style>